import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { SearchIcon, SearchIconWrapper, SearchInputField } from './Styles';
import { SEARCH_KEY } from '../../_shared/constants/search';
import MixpanelService from '../../services/MixpanelService';
import mixpanelConfig from '../../_shared/constants/mixpanelConfig';

const mixpanel = MixpanelService.get();

const useKeyDownListener = (isModalOpen, callback) => {
  useEffect(() => {
    const keyDownHandler = event => {
      if (
        event.keyCode === SEARCH_KEY.TRIGGER &&
        !document.activeElement.matches('textarea') &&
        !document.activeElement.matches('input') &&
        !document.activeElement.className.includes('ReactModal')
      ) {
        event.preventDefault();
        mixpanel.track(mixpanelConfig.names.searchUsingShortcut, {
          shortcut_type: 's'
        });
        callback();
      }
    };
    if (!isModalOpen) {
      document.addEventListener('keydown', keyDownHandler);
    } else {
      document.removeEventListener('keydown', keyDownHandler);
    }
    return () => document.removeEventListener('keydown', keyDownHandler);
  }, [isModalOpen, callback]);
};

const propTypes = {
  isModalOpen: PropTypes.bool,
  openModalHandler: PropTypes.func.isRequired
};

const defaultProps = {
  isModalOpen: false
};

const NavSearchBar = ({ testId, isModalOpen, openModalHandler }) => {
  const intl = useIntl();

  useKeyDownListener(isModalOpen, openModalHandler);

  return (
    <div data-testid={testId}>
      <SearchIconWrapper>
        <SearchIcon />
      </SearchIconWrapper>
      <SearchInputField
        data-testid={`${testId}-searchbar`}
        readOnly
        type="text"
        name="searchBar"
        placeholder={intl.formatMessage({
          id: 'list.nav.searchbar.placeholder'
        })}
        onClick={openModalHandler}
      />
    </div>
  );
};

NavSearchBar.propTypes = propTypes;
NavSearchBar.defaultProps = defaultProps;

export default NavSearchBar;
